import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";

export const UpdatePasswordPage = ({ userUpdate, loggedUser, isLoading }) => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    userUpdate(data);
  };

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">Update Password</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-white">Home</a>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">Update Password</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <main>
        <div class="my-4 px-3" style={{ maxWidth: "1000px", margin: "auto" }}>
            <div class="container">
                <div class="row">
                    <div class="col-12 d-md-none mb-3">
                        <button class="btn btn-dark" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar" aria-controls="offcanvasSidebar">
                            <i class="bi bi-list"></i>
                        </button>
                    </div>
            
                    <div className="offcanvas offcanvas-start d-md-none" id="offcanvasSidebar" tabIndex="-1" aria-labelledby="offcanvasSidebarLabel">
                        <div class="offcanvas-header">
                            <h5 class="offcanvas-title" id="offcanvasSidebarLabel">Dashboard</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div class="offcanvas-body">
                            <div class="box1-list">
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>Orders</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>Edit Profile</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/update-password")}>Change Passwords</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => {
                                    sessionStorage.removeItem("loggedUser");
                                    sessionStorage.removeItem("userToken");
                                    window.location.href = "/login"
                                }}>Logout</h6>
                            </div>
                        </div>
                    </div>
            
                    <div class="col-md-4 d-none d-md-block">
                        <div class="box1">
                            <div class="heading">
                                <h3 class="profile-heading">
                                    Orders
                                    <span style={{ display: "inline-block", borderBottom: "3px solid black", width: "12%", textAlign: "left", marginTop: "10px"}}>
                                    </span>
                                </h3>
                            </div>
                            <div class="box1-list">
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/orders")}>Orders</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>Edit Profile</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => navigate("/update-password")}>Change Passwords</h6>
                                <hr />
                                <h6 style={{ cursor: "pointer" }} onClick={() => {
                                    sessionStorage.removeItem("loggedUser");
                                    sessionStorage.removeItem("userToken");
                                    window.location.href = "/login"
                                }}>Logout</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <h3 class="profile-heading">Update Password
                            <span style={{ display: "inline-block", borderBottom: "3px solid black", width: "6%", textAlign: "left", marginTop: "10px"}}>
                            </span>
                        </h3>
                        {/* <div class="align-items-center upload-image">
                            <img src="./images/profile.jpg" alt="Profile Picture" class="rounded-circle img-thumbnail me-3" width="135px" />
                            <button class="btn btn-dark upload-btn">Upload</button>
                        </div> */}
                        <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3">
                                <label for="password" className="form-label text-secondary">Password<span className="text-danger">*</span></label>
                                <input type="password" name="password" {...register('password', { required: 'Password is required' })} className="form-control" id="password" placeholder="Type Password"/>
                                {errors.password && <p className="text-danger px-2">{errors.password.message}</p>}
                            </div>
                            <div className="mb-3">
                                <label for="confirm_password" className="form-label text-secondary">Confirm Password<span className="text-danger">*</span></label>
                                <input type="password" name="confirm_password" {...register('confirm_password', {
                                                        required: "Please confirm your password",
                                                        validate: (value) =>
                                                            value === watch("password") || "Passwords do not match",
                                                        })} className="form-control" id="confirm_password" placeholder="Type Password"/>
                                {errors.confirm_password && <p className="text-danger px-2">{errors.confirm_password.message}</p>}
                            </div>
                
                            <button type="submit" className="btn w-100"
                                style={{backgroundColor: "#424A4D", borderRadius: 0, color: "white", height: "40px"}}>Update Password</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </>
  );
};
